import styled from 'styled-components';

import CommonButton from '~atoms/CommonButton';

export const OptionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: '20rem',
  flexWrap: 'wrap',
  paddingBottom: '25rem',
  marginLeft: '20rem',
  marginTop: '20rem',
  columnGap: '20rem',
});

export const OptionButton = styled(CommonButton)(({ theme }) => ({
  border: 'unset',
  transition: 'border-color 250ms ease-in',
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
  color: theme.palette.erieBlack,
  borderRadius: '20rem',
  boxShadow: `0 2rem 3rem ${theme.palette.superLightGray}`,

  '&[data-is-selected="true"]': {
    border: `2rem solid ${theme.palette.darkLiver}`,
  },
}));
